import {RouteHelper} from "../../route/RouteHelper";

export const advanceSidebarItemTypes = {
    COLLAPSE: "COLLAPSE",
    SIMPLE_ITEM: "SIMPLE_ITEM",
    SIMPLE_CHILD: "SIMPLE_CHILD",
    ROOT_ITEM: "ROOT_ITEM",
}

export const advanceSidebarItems = [
    {
        info: RouteHelper.Dashboard,
        type: advanceSidebarItemTypes.SIMPLE_ITEM,
        parent: null
    },
    {
        info: RouteHelper.Game,
        type: advanceSidebarItemTypes.ROOT_ITEM,
        parent: null
    },
    {
        info: RouteHelper.GamePeriod,
        type: advanceSidebarItemTypes.SIMPLE_CHILD,
        parent: RouteHelper.Game
    },
    {
        info: RouteHelper.Games,
        type: advanceSidebarItemTypes.SIMPLE_CHILD,
        parent: RouteHelper.Game
    },


    // Habitation
    {
        type: advanceSidebarItemTypes.ROOT_ITEM,
        info: RouteHelper.Habitation,
        parent: null
    },
    {
        info: RouteHelper.PeriodList,
        type: advanceSidebarItemTypes.SIMPLE_CHILD,
        parent: RouteHelper.Habitation
    },
    {
        info: RouteHelper.Residences,
        type: advanceSidebarItemTypes.SIMPLE_CHILD,
        parent: RouteHelper.Habitation
    },
    {
        info: RouteHelper.ResidencesManager,
        type: advanceSidebarItemTypes.SIMPLE_CHILD,
        parent: RouteHelper.Habitation
    },
    {
        info: RouteHelper.HabitationReports,
        type: advanceSidebarItemTypes.SIMPLE_CHILD,
        parent: RouteHelper.Habitation
    },
    {
        info: RouteHelper.MawakibManager,
        type: advanceSidebarItemTypes.ROOT_ITEM,
        parent: null
    },
    {
        info: RouteHelper.MawakibManagerList,
        type: advanceSidebarItemTypes.SIMPLE_CHILD,
        parent: RouteHelper.MawakibManager
    },
    {
        info: RouteHelper.MawakibServiceList,
        type: advanceSidebarItemTypes.SIMPLE_CHILD,
        parent: RouteHelper.MawakibManager
    },
    {
        info: RouteHelper.MawkibRegistrationLicense,
        type: advanceSidebarItemTypes.SIMPLE_CHILD,
        parent: RouteHelper.MawakibManager
    },
    {
        info: RouteHelper.MawakibRegistrationLocation,
        type: advanceSidebarItemTypes.SIMPLE_CHILD,
        parent: RouteHelper.MawakibManager
    },

    // Magazine
    {
        type: advanceSidebarItemTypes.ROOT_ITEM,
        info: RouteHelper.Magazine,
        parent: null
    },
    {
        type: advanceSidebarItemTypes.SIMPLE_CHILD,
        info: RouteHelper.MagazineList,
        parent: RouteHelper.Magazine
    }, {
        type: advanceSidebarItemTypes.SIMPLE_CHILD,
        info: RouteHelper.MagazineWriters,
        parent: RouteHelper.Magazine
    }, {
        type: advanceSidebarItemTypes.SIMPLE_CHILD,
        info: RouteHelper.MagazineCategory,
        parent: RouteHelper.Magazine
    }, {
        type: advanceSidebarItemTypes.SIMPLE_CHILD,
        info: RouteHelper.TagList,
        parent: RouteHelper.Magazine
    }, {
        type: advanceSidebarItemTypes.SIMPLE_CHILD,
        info: RouteHelper.FileManager,
        parent: RouteHelper.Magazine
    },
    {
        type: advanceSidebarItemTypes.ROOT_ITEM,
        info: RouteHelper.Store,
        parent: null
    },
    {
        type: advanceSidebarItemTypes.SIMPLE_CHILD,
        info: RouteHelper.Products,
        parent: RouteHelper.Store
    },
    {
        type: advanceSidebarItemTypes.ROOT_ITEM,
        info: RouteHelper.Tourism,
        parent: null
    },
    {
        type: advanceSidebarItemTypes.SIMPLE_CHILD,
        info: RouteHelper.TourismPlaceList,
        parent: RouteHelper.Tourism
    },
    {
        type: advanceSidebarItemTypes.SIMPLE_CHILD,
        info: RouteHelper.TourismCategory,
        parent: RouteHelper.Tourism
    },
    {
        type: advanceSidebarItemTypes.SIMPLE_CHILD,
        info: RouteHelper.TourismReport,
        parent: RouteHelper.Tourism
    },
    {
        type: advanceSidebarItemTypes.SIMPLE_CHILD,
        info: RouteHelper.Campaigns,
        parent: RouteHelper.Tourism
    },
    {
        type: advanceSidebarItemTypes.ROOT_ITEM,
        info: RouteHelper.Vow,
        parent: null
    },
    {
        type: advanceSidebarItemTypes.SIMPLE_CHILD,
        info: RouteHelper.VowList,
        parent: RouteHelper.Vow
    },
    {
        type: advanceSidebarItemTypes.SIMPLE_CHILD,
        info: RouteHelper.VowPayments,
        parent: RouteHelper.Vow
    },
    //memorial-note
    {
        type: advanceSidebarItemTypes.ROOT_ITEM,
        info: RouteHelper.MemorialNote,
        parent: null
    },
    {
        type: advanceSidebarItemTypes.SIMPLE_CHILD,
        info: RouteHelper.MemorialNotes,
        parent: RouteHelper.MemorialNote
    },


    // Managers
    {
        type: advanceSidebarItemTypes.ROOT_ITEM,
        info: RouteHelper.Managers,
        parent: null
    },
    {
        type: advanceSidebarItemTypes.SIMPLE_CHILD,
        info: RouteHelper.ManagersList,
        parent: RouteHelper.Managers
    },
    {
        type: advanceSidebarItemTypes.SIMPLE_CHILD,
        info: RouteHelper.ManagersAccess,
        parent: RouteHelper.Managers
    },

    // Payment
    {
        type: advanceSidebarItemTypes.ROOT_ITEM,
        info: RouteHelper.PaymentGateway,
        parent: null
    }, {
        type: advanceSidebarItemTypes.SIMPLE_CHILD,
        info: RouteHelper.PaymentGatewaysList,
        parent: RouteHelper.PaymentGateway
    }, {
        type: advanceSidebarItemTypes.SIMPLE_CHILD,
        info: RouteHelper.TransactionsList,
        parent: RouteHelper.PaymentGateway,
    },

    // Users
    {
        type: advanceSidebarItemTypes.ROOT_ITEM,
        info: RouteHelper.Users,
        parent: null
    },
    {
        info: RouteHelper.UsersList,
        type: advanceSidebarItemTypes.SIMPLE_CHILD,
        parent: RouteHelper.Users
    },
    {
        info: RouteHelper.UsersAvatar,
        type: advanceSidebarItemTypes.SIMPLE_CHILD,
        parent: RouteHelper.Users
    },
    {
        info: RouteHelper.UsersFileManager,
        type: advanceSidebarItemTypes.SIMPLE_CHILD,
        parent: RouteHelper.Users
    },
    {
        type: advanceSidebarItemTypes.ROOT_ITEM,
        info: RouteHelper.Android,
        parent: null
    },
    {
        info: RouteHelper.OccasionalBanner,
        type: advanceSidebarItemTypes.SIMPLE_CHILD,
        parent: RouteHelper.Android
    },
    {
        info: RouteHelper.AppVersionList,
        type: advanceSidebarItemTypes.SIMPLE_CHILD,
        parent: RouteHelper.Android
    },
    {
        type: advanceSidebarItemTypes.ROOT_ITEM,
        info: RouteHelper.Settings,
        parent: null
    },
    {
        info: RouteHelper.HabitationSettings,
        type: advanceSidebarItemTypes.SIMPLE_CHILD,
        parent: RouteHelper.Settings
    },
    {
        info: RouteHelper.LanguageSetting,
        type: advanceSidebarItemTypes.SIMPLE_CHILD,
        parent: RouteHelper.Settings
    },

    //Etekaf
    {
        info: RouteHelper.EtekafManagerList,
        type: advanceSidebarItemTypes.SIMPLE_ITEM,
        parent: null
    }

    /* {
         info: RouteHelper.ReleaseDocuments,
         type: advanceSidebarItemTypes.ROOT_ITEM,
         parent: null
     },*/

]
